import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { InitBackpainTrackerPage } from './init-backpain-tracker';
import {PipesModule} from "../../pipes/pipes.module";
import {DirectivesModule} from "../../directives/directives.module";

@NgModule({
  declarations: [
    InitBackpainTrackerPage,
  ],
  imports: [
    IonicPageModule.forChild(InitBackpainTrackerPage),
    PipesModule,
    DirectivesModule,

  ],
})
export class InitBackpainTrackerPageModule {}



// WEBPACK FOOTER //
// ./src/pages/init-backpain-tracker/init-backpain-tracker.module.ts